import "./GameMode.css"
import {useTranslation} from "react-i18next";

export default function GameMode(props: {
    id: string
}) {
    const { id } = props;
    const {t} = useTranslation();

    return <div className={"gamemode"}>
        <div className={"image"}>
            <img src={`/img/gamemode/${id}.webp`} alt={""}/>
        </div>
        <div className={"content"}>
            <p className={"name"}>{t(`home.gamemode.${id}.name`)}</p>
            <p className={"description"}>{t(`home.gamemode.${id}.desc`)}</p>
        </div>
    </div>
}